import { render, staticRenderFns } from "./CarHealthTabWarnings.vue?vue&type=template&id=4f1c133b&"
import script from "./CarHealthTabWarnings.vue?vue&type=script&lang=ts&"
export * from "./CarHealthTabWarnings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports